<template>
    <v-dialog persistent v-model="get_dialogMain.dialog" width="800px" justify-center>
        <v-toolbar dense dark color="blue darken-2">
            <v-toolbar-title>
                <h3 v-if="get_dialogMain.type == 'create'">Nuevo Usuario </h3>
                <h3 v-else>Editar Usuario </h3>
            </v-toolbar-title>
        <v-spacer></v-spacer>
            <v-btn icon dark @click="HIDDE_DIALOG_MAIN()">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>
            <UserForm :model="user" :on-success="saveUser" :on-cancel="cancel" />
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import UserForm from '@/components/forms/UserForm'
export default {
  data: () => ({
    user: {}
  }),
  components: {
    UserForm
  },
  methods: {
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postUrlServicesAction({ url: router, data: this.user })
      } else {
        this.getUrlServices()
      }
    },
    ...mapActions(['getUrlServices', 'postUrlServicesAction']),
    saveUser (model) {
      this.user = model
      this.getUrl('usr.add')
    },
    cancel () {
      this.HIDDE_DIALOG_MAIN()
    },
    ...mapMutations(['HIDDE_DIALOG_MAIN', 'CLEAR_DATA_MAIN', 'SET_DATA_USER'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_object'])
  },
  watch: {
    get_urls (vals) {
      this.getUrl('usr.add')
    },
    get_object (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitos!',
        text: 'Se registro correctamente el usuario'
      })
      this.SET_DATA_USER(val.user)
      this.cancel()
    }
  },
  beforeDestroy () {
    this.CLEAR_DATA_MAIN()
  }
}
</script>

<style>

</style>
